import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Structure from './components/Structure';
import Guarantee from './components/Guarantee';
import Pricing from './components/Pricing';
import Circles from './components/Circles';
import TargetAudience from './components/TargetAudience';
import Process from './components/Process';
import CaseStudies from './components/CaseStudies';
import CTA from './components/CTA';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-brand-black relative text-brand-text">
      <Navbar />
      <Hero />
      <About />
      <Structure />
      <Guarantee />
      <Pricing />
      <Circles />
      <TargetAudience />
      <Process />
      <CaseStudies />
      <CTA />
      <Footer />
    </div>
  );
}

export default App;